import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import 'highcharts/highcharts-more';
import 'highcharts/modules/boost';
import 'highcharts/modules/broken-axis';
import 'highcharts/modules/exporting';
import 'highcharts/modules/heatmap';
import 'highcharts/modules/pareto';
import 'highcharts/modules/pattern-fill';
import 'highcharts/modules/solid-gauge';

@Injectable({
    providedIn: 'root'
})
export class HighchartsProvider {
    private _translateService = inject(TranslateService);

    init() {
        this.listenToTranslationChanges();
        this.autoReflowOnPrint();
    }

    private listenToTranslationChanges() {
        this._translateService.onLangChange.subscribe(() => {
            const tr = (toTranslate: string) => this._translateService.instant(`HIGHCHARTS.${toTranslate}`);
            const highchartsOptions: Highcharts.Options = {
                lang: {
                    loading: tr('LOADING'),
                    months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => tr(`MONTHS.${i}`)),
                    weekdays: [1, 2, 3, 4, 5, 6, 7].map(i => tr(`WEEK_DAYS.${i}`)),
                    shortMonths: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => tr(`SHORT_MONTHS.${i}`)),
                    thousandsSep: tr('THOUSAND_STEP'),
                    decimalPoint: tr('DECIMAL_POINT'),
                    downloadCSV: tr('DOWNLOAD_CSV'),
                    downloadXLS: tr('DOWNLOAD_XLS'),
                    downloadPDF: tr('DOWNLOAD_PDF'),
                    downloadPNG: tr('DOWNLOAD_PNG'),
                    resetZoomTitle: tr('RESET_ZOOM_TITLE'),
                    resetZoom: tr('RESET_ZOOM')
                }
            };
            Highcharts.setOptions(highchartsOptions);
        });
    }

    private autoReflowOnPrint() {
        // Print
        const beforePrint = function () {
            Highcharts.charts.forEach(chart => {
                if (chart) {
                    chart.reflow();
                }
            });
        };
        const afterPrint = function () {
            Highcharts.charts.forEach(chart => {
                if (chart) {
                    chart.reflow();
                }
            });
        };

        if (window.matchMedia) {
            const mediaQueryList = window.matchMedia('print');
            mediaQueryList.addListener(function (mql) {
                if (mql.matches) {
                    beforePrint();
                } else {
                    afterPrint();
                }
            });
        }
    }
}
